import PropTypes from "prop-types"
import usePrice from "hooks/usePrice/usePrice"

const PriceRange = ({
  minPrice,
  maxPrice,
  shouldRenderCurrency = true,
  shouldCompact = false,
  digitAfterFraction = 0,
  showCurrencySymbolWithMinPrice = true,
  showCurrencySymbolWithMaxPrice = false,
  separator = " – ",
  loading = false,
  className,
  style,
  loadingProps,
  ...rest
}) => {
  const { getPriceRange } = usePrice()

  return (
    <div className={className} style={style} {...rest}>
      {getPriceRange({
        minPrice,
        maxPrice,
        shouldRenderCurrency,
        shouldCompact,
        digitAfterFraction,
        showCurrencySymbolWithMinPrice,
        showCurrencySymbolWithMaxPrice,
        separator,
        loading,
        loadingProps,
      })}
    </div>
  )
}

PriceRange.propTypes = {
  minPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shouldRenderCurrency: PropTypes.bool,
  shouldCompact: PropTypes.bool,
  digitAfterFraction: PropTypes.number,
  showCurrencySymbolWithMinPrice: PropTypes.bool,
  showCurrencySymbolWithMaxPrice: PropTypes.bool,
  separator: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

PriceRange.defaultProps = {
  shouldRenderCurrency: true,
  shouldCompact: false,
  digitAfterFraction: 0,
  showCurrencySymbolWithMinPrice: true,
  showCurrencySymbolWithMaxPrice: false,
  separator: " – ",
  loading: false,
}

export default PriceRange
